export const GuardiansCollection = 'guardians'
export const AllianceEventsCollection = 'allianceEvents'